import { render, staticRenderFns } from "./AIOverview.vue?vue&type=template&id=f805424e&scoped=true"
import script from "./AIOverview.vue?vue&type=script&lang=js"
export * from "./AIOverview.vue?vue&type=script&lang=js"
import style0 from "./AIOverview.vue?vue&type=style&index=0&id=f805424e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f805424e",
  null
  
)

export default component.exports